import * as React from "react";

const SvgSunrise = (props) => (
  <svg
    viewBox="0 0 57 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.18 41.113a11.76 11.76 0 0 0-23.521 0M28.42 3.478v16.466M10.12 22.813l3.34 3.34M2.546 41.113H7.25M49.589 41.113h4.704M43.379 26.153l3.34-3.34M54.293 50.522H2.546M19.01 12.887l9.41-9.409 9.408 9.41"
      stroke="currentColor"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgSunrise;
